import React from "react";

const RentalPropertyPage = () => {
  const sectionData = [
    {
      title: "Now Renting Made Simple",
      description:
        "We help you find your perfect rental home in a few easy steps! With Housing.in, the entire process becomes seamless and stress-free.",
      items: [
        {
          text: "Search Properties - Search from a wide range of verified properties.",
          image: "/searchProperties.png",
        },
        {
          text: "Find a Property - Shortlist properties that suit your requirements.",
          image: "/shortlist.png",
        },
        {
          text: "Schedule Tours - We guide you through the property and help you finalize one.",
          image: "/sitevisits.png",
        },
        {
          text: "Possession - Complete the documentation & agreement formalities to get possession.",
          image: "/shortlist.png",
        },
        {
          text: "Sign an Agreement - Understand all terms & conditions before signing.",
          image: "/legal.png",
        },
        {
          text: "Negotiation - We negotiate on your behalf for the best possible deal.",
          image: "/pricenegotiation.png",
        },
        {
          text: "Pay Rent Online - Use our tools to pay rent online with ease.",
          image: "/deals.png",
        },
        {
          text: "Trust & Safety - Enjoy streamlined services and ‘No Brokerage’ benefits.",
          image: "/expert.png",
        },
      ],
    },
    {
      title: "Why Choose Housing.in?",
      description:
        "We offer a variety of services that make the entire rental search seamless for you!",
      items: [
        {
          text: "No Brokerage",
          image: "/deals.png",
        },
        {
          text: "Verified Listings",
          image: "/shortlist.png",
        },
        {
          text: "Instant Possession",
          image: "/sitevisits.png",
        },
        {
          text: "End-to-End Customer Assistance",
          image: "/expert.png",
        },
        {
          text: "Documentation & Legal Assistance",
          image: "/legal.png",
        },
      ],
    },
    {
      title: "Unique Offerings at Housing.in",
      description:
        "Get detailed insights and an enhanced property viewing experience with our unique offerings.",
      items: [
        {
          text: "Street View - Get a broader view of the locality and its surroundings.",
          image: "/sitevisits.png",
        },
        {
          text: "360° View - Enjoy a 360° virtual tour of the property.",
          image: "/homeLoans.png",
        },
        {
          text: "Photographs - Clear photographs give you an exact idea of the property.",
          image: "/searchProperties.png",
        },
        {
          text: "Site Visit Assistance - Dedicated field executives guide you through the property.",
          image: "/sitevisits.png",
        },
        {
          text: "Tour Via Video Chat - View the property from wherever you are with video chat tours.",
          image: "/expert.png",
        },
      ],
    },
  ];

  return (
    <div className="p-6 bg-gray-50">
      {/* Header Section */}
      <header className="text-center py-6">
        <h1 className="text-3xl font-bold text-gray-800">
          Rental Property Search Got You Down?
        </h1>
        <p className="text-gray-600 mt-2">
          Discover Your Perfect Rental Home with <span className="text-blue-600">Housing.in</span>
        </p>
      </header>

      {/* Sections */}
      {sectionData.map((section, index) => (
        <section key={index} className="my-8">
          <div className="bg-white shadow-lg rounded-lg p-6 border-l-4 border-blue-500 hover:shadow-xl transition duration-300">
            <h2 className="text-xl font-semibold text-gray-800 mb-4">
              {section.title}
            </h2>
            {section.description && (
              <p className="text-gray-600 mb-4">{section.description}</p>
            )}
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              {section.items.map((item, idx) => (
                <div
                  key={idx}
                  className="flex items-center bg-gray-50 shadow-md rounded-lg p-4"
                >
                  <img
                    src={item.image}
                    alt={item.text}
                    className="w-16 h-16 rounded-full border-2 border-blue-500 mr-4"
                  />
                  <p className="text-gray-700">{item.text}</p>
                </div>
              ))}
            </div>
          </div>
        </section>
      ))}
    </div>
  );
};

export default RentalPropertyPage;
